/*
 * Comportamiento común del tema Aetheria Design. Reproduce los componentes de cliente de la
 * web (Header, WorldTransition, HeroVideo, CartDrawer, SearchDialog, Toast, CookieBanner)
 * sobre la API AJAX de Shopify, sin dependencias.
 */
(function () {
  var A = (window.Aetheria = window.Aetheria || {});
  var fmt = new Intl.NumberFormat('es-ES', { style: 'currency', currency: 'EUR', minimumFractionDigits: 2 });
  var euro = (A.euro = function (c) { return fmt.format(c / 100); });
  var esc = function (s) {
    return String(s == null ? '' : s).replace(/[&<>"']/g, function (c) { return { '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;', "'": '&#39;' }[c]; });
  };
  var $ = function (sel, el) { return (el || document).querySelector(sel); };
  var $$ = function (sel, el) { return Array.prototype.slice.call((el || document).querySelectorAll(sel)); };
  var reduced = function () { return matchMedia('(prefers-reduced-motion: reduce)').matches; };

  /* ------------------------------------------------------------------ Toast */
  var toastTimer = null;
  A.toast = function (message) {
    var el = $('.toast');
    if (!el) return;
    el.textContent = message;
    clearTimeout(toastTimer);
    toastTimer = setTimeout(function () { el.textContent = ''; }, 3200);
  };

  /* ------------------------------------------------------------ Mega menú */
  var menu = $('#shop-menu');
  var scrim = $('[data-menu-scrim]');
  var menuTrigger = null;
  function setMenu(open) {
    if (!menu) return;
    menu.hidden = !open;
    scrim.hidden = !open;
    $$('[data-menu-toggle]').forEach(function (b) { b.setAttribute('aria-expanded', open); });
    if (open) { var first = $('a', menu); if (first) first.focus(); }
  }
  $$('[data-menu-toggle]').forEach(function (b) {
    b.addEventListener('click', function () { menuTrigger = b; setMenu(menu.hidden); });
  });
  if (scrim) scrim.addEventListener('click', function () { setMenu(false); });
  document.addEventListener('keydown', function (e) {
    if (e.key === 'Escape' && menu && !menu.hidden) { setMenu(false); if (menuTrigger) menuTrigger.focus(); }
  });
  if (menu) menu.addEventListener('focusout', function (e) {
    var next = e.relatedTarget;
    if (next && !menu.contains(next) && next !== menuTrigger) setMenu(false);
  });

  /* ---------------------------------------- Transición tienda ↔ Business */
  // La primera vez dura 2,6 s y después 0,55 s. La capa se pinta aquí, se navega cuando ya
  // cubre la pantalla, y layout/theme.liquid la continúa en la página de destino.
  var LONG = 2600, QUICK = 550;
  function finishTransition(el) {
    if (!el || !el.parentNode) return;
    el.parentNode.removeChild(el);
    window.scrollTo(0, 0);
  }
  if (window.__aetheriaTransition) {
    var t = window.__aetheriaTransition;
    var btn = $('button', t.el);
    btn.addEventListener('click', function () { finishTransition(t.el); });
    btn.focus();
    setTimeout(function () { finishTransition(t.el); }, Math.max(0, t.remaining));
  }
  var isBusiness = function (href) { return /\/pages\/business(?:[?#]|$)/.test(href); };
  document.addEventListener('click', function (e) {
    var link = e.target.closest('a[data-world-link]');
    if (!link || e.defaultPrevented || e.metaKey || e.ctrlKey || e.shiftKey || e.button !== 0) return;
    var url = new URL(link.href, location.href);
    var fromBusiness = document.body.dataset.world === 'business';
    var toBusiness = isBusiness(url.pathname);
    if (fromBusiness === toBusiness) return; // mismo mundo: navegación normal
    if (reduced()) return;
    e.preventDefault();
    var seen = false;
    try {
      seen = sessionStorage.getItem('aetheria-world-seen') === 'yes';
      sessionStorage.setItem('aetheria-world-seen', 'yes');
    } catch (err) {}
    var label = toBusiness ? 'Entrando en Design Business' : 'Volviendo a Aetheria Design';
    var duration = seen ? QUICK : LONG;
    var el = document.createElement('div');
    el.className = 'world-transition' + (seen ? ' quick' : '');
    el.setAttribute('aria-live', 'polite');
    el.innerHTML = '<span class="transition-line" aria-hidden="true"></span><img src="' + esc(A.logo) + '" alt="" width="90" height="80"><p>' + esc(label) + '</p><button type="button">Omitir transición →</button>';
    document.body.appendChild(el);
    var go = function () { location.href = url.href; };
    $('button', el).addEventListener('click', go);
    $('button', el).focus();
    try {
      sessionStorage.setItem('aetheria-world-transition', JSON.stringify({ label: label, quick: seen, start: Date.now(), duration: duration }));
    } catch (err) {}
    // La capa entra en el primer 20 % de la animación: se navega cuando ya tapa la página.
    setTimeout(go, duration * 0.2);
  });

  /* ------------------------------------------------------- Vídeo del hero */
  $$('[data-hero-motion]').forEach(function (section) {
    var scene = $('[data-hero-video]', section);
    var video = scene && $('video', scene);
    var button = $('[data-motion-button]', section);
    if (!video) return;
    var KEY = 'ad-hero-paused';
    var paused = false;
    try { paused = sessionStorage.getItem(KEY) === '1'; } catch (e) {}
    var mobile = matchMedia('(max-width: 740px)');
    var reducedQ = matchMedia('(prefers-reduced-motion: reduce)');
    var visible = false, blocked = false, source = '';
    function refresh() {
      var src = mobile.matches ? scene.dataset.vertical : scene.dataset.horizontal;
      var conn = navigator.connection;
      var play = visible && !document.hidden && !blocked && !reducedQ.matches && !(conn && conn.saveData) && !paused;
      if (play && source !== src) { video.classList.remove('ready'); video.src = src; source = src; }
      if (play && !video.ended) { var p = video.play(); if (p) p.catch(function () { blocked = true; }); }
      else video.pause();
    }
    function paintButton() {
      if (!button) return;
      button.setAttribute('aria-pressed', paused);
      button.innerHTML = (paused ? 'Reanudar el fondo' : 'Pausar el fondo') + ' <span aria-hidden="true">' + (paused ? '▶' : '❚❚') + '</span>';
    }
    video.addEventListener('loadeddata', function () { video.classList.add('ready'); });
    new IntersectionObserver(function (changes) { visible = changes[0] ? changes[0].isIntersecting : false; refresh(); }, { threshold: 0.1 }).observe(scene);
    mobile.addEventListener('change', refresh);
    reducedQ.addEventListener('change', refresh);
    document.addEventListener('visibilitychange', refresh);
    if (button) button.addEventListener('click', function () {
      paused = !paused;
      try { sessionStorage.setItem(KEY, paused ? '1' : '0'); } catch (e) {}
      paintButton();
      refresh();
    });
    paintButton();
  });

  /* ---------------------------------------------------------------- Cesta */
  var drawer = $('[data-cart-drawer]');
  var cartState = null;
  function request(url, body) {
    return fetch(url, {
      method: body ? 'POST' : 'GET',
      headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
      body: body ? JSON.stringify(body) : undefined
    }).then(function (r) {
      return r.json().then(function (j) {
        if (!r.ok) throw new Error(j.description || j.message || 'No se pudo actualizar la cesta.');
        return j;
      });
    });
  }
  function refreshCart() {
    return request(A.routes.cart + '.js').then(function (cart) { cartState = cart; paintCart(); return cart; });
  }
  function paintCount(count) {
    $$('[data-cart-count]').forEach(function (el) { el.textContent = count; });
    var label = 'Abrir cesta, ' + count + ' ' + (count === 1 ? 'producto' : 'productos');
    $$('[data-cart-open]').forEach(function (el) { el.setAttribute('aria-label', label); });
  }
  function colorOf(item) {
    var c = (item.options_with_values || []).filter(function (o) { return o.name === 'Color'; })[0];
    return c ? c.value : 'Modelo original';
  }
  function paintCart() {
    if (!cartState || !drawer) return;
    var items = cartState.items;
    paintCount(cartState.item_count);
    var list = $('#cart-items', drawer);
    var end = $('#cart-end', drawer);
    if (!items.length) {
      list.innerHTML = $('[data-cart-empty]', drawer).innerHTML;
      end.hidden = true;
      return;
    }
    list.innerHTML = items.map(function (item) {
      var text = item.properties && item.properties['Texto grabado'];
      return '<article class="cart-item"><div class="cart-item-row">' +
        (item.image ? '<a href="' + esc(item.url) + '" class="cart-thumb"><img src="' + esc(item.image + (item.image.indexOf('?') === -1 ? '?' : '&') + 'width=160') + '" alt=""></a>' : '') +
        '<div class="cart-item-main"><strong><a href="' + esc(item.url) + '">' + esc(item.product_title) + '</a></strong>' +
        '<p>' + esc(colorOf(item)) + (text ? ' · «' + esc(text) + '»' : '') + '</p>' +
        '<p class="cart-item-price">' + euro(item.final_line_price) + '</p></div></div>' +
        '<div class="cart-item-actions"><div class="quantity">' +
        '<button type="button" aria-label="Restar una unidad de ' + esc(item.product_title) + '"' + (item.quantity === 1 ? ' disabled' : '') + ' data-key="' + esc(item.key) + '" data-qty="' + (item.quantity - 1) + '">−</button>' +
        '<span aria-live="polite" aria-atomic="true">' + item.quantity + '</span>' +
        '<button type="button" aria-label="Sumar una unidad de ' + esc(item.product_title) + '" data-key="' + esc(item.key) + '" data-qty="' + (item.quantity + 1) + '">+</button></div>' +
        '<button type="button" aria-label="Quitar ' + esc(item.product_title) + ' de la cesta" data-key="' + esc(item.key) + '" data-qty="0">Quitar</button></div></article>';
    }).join('');
    end.hidden = false;
    $('[data-cart-subtotal]', end).textContent = euro(cartState.total_price);
    var missing = A.freeShippingCents - cartState.total_price;
    $('[data-free-shipping]', end).innerHTML = missing > 0
      ? 'Te faltan <b>' + euro(missing) + '</b> para el envío gratis en península.'
      : '<b>Envío gratis</b> en península. También puedes recogerlo en Lugo sin coste.';
  }
  A.cart = {
    add: function (item) {
      return request(A.routes.cartAdd, { items: [item] }).then(refreshCart);
    },
    change: function (key, quantity) {
      return request(A.routes.cartChange, { id: key, quantity: quantity }).then(function (cart) { cartState = cart; paintCart(); return cart; });
    },
    open: function () {
      if (!drawer) return;
      if (!drawer.open) drawer.showModal();
      (cartState ? Promise.resolve() : refreshCart()).then(paintCart);
    },
    close: function () { if (drawer && drawer.open) drawer.close(); }
  };
  $$('[data-cart-open]').forEach(function (b) { b.addEventListener('click', A.cart.open); });
  if (drawer) {
    $('[data-cart-close]', drawer).addEventListener('click', A.cart.close);
    drawer.addEventListener('click', function (e) {
      var b = e.target.closest('button[data-key]');
      if (b) { b.disabled = true; A.cart.change(b.dataset.key, +b.dataset.qty); return; }
      if (e.target !== drawer) return;
      // Solo cerramos si el clic cae FUERA del cuadro: el relleno interior también tiene como destino el <dialog>.
      var r = drawer.getBoundingClientRect();
      if (e.clientX < r.left || e.clientX > r.right || e.clientY < r.top || e.clientY > r.bottom) A.cart.close();
    });
  }

  /* ------------------------------------------------------------- Buscador */
  var search = $('[data-search-dialog]');
  var index = null;
  function loadIndex() {
    if (index) return Promise.resolve(index);
    return fetch(A.routes.all + '?view=index-json', { headers: { Accept: 'application/json' } })
      .then(function (r) { return r.json(); })
      .then(function (j) { index = j; return j; })
      .catch(function () { index = []; return index; });
  }
  function paintSearch() {
    var input = $('#search-input', search);
    var normalize = function (s) { return s.normalize('NFD').replace(/[̀-ͯ]/g, '').toLocaleLowerCase('es'); };
    var t = normalize(input.value.trim());
    var list = (index || []).filter(function (p) { return !t || normalize(p.name + ' ' + p.category).indexOf(t) !== -1; });
    $('[data-search-status]', search).textContent = list.length === 0 ? 'Sin resultados'
      : list.length + ' ' + (list.length === 1 ? 'resultado' : 'resultados') + '. Enter abre: ' + list[0].name;
    $('#search-results', search).innerHTML = list.length
      ? '<ul>' + list.map(function (p) {
          return '<li><a class="search-result" href="' + esc(p.url) + '"><span>' + esc(p.name) + '<br><small>' + esc(p.category) +
            (p.personal ? ' · Personalizable' : '') + ' · ' + euro(p.priceCents) + '</small></span><span aria-hidden="true">↗</span></a></li>';
        }).join('') + '</ul>'
      : '<p>No encontramos esa pieza. Prueba con otro nombre.</p>';
    return list;
  }
  if (search) {
    var input = $('#search-input', search);
    $$('[data-search-open]').forEach(function (b) {
      b.addEventListener('click', function () {
        input.value = '';
        search.showModal();
        input.focus();
        loadIndex().then(paintSearch);
      });
    });
    $('[data-search-close]', search).addEventListener('click', function () { search.close(); });
    input.addEventListener('input', paintSearch);
    input.addEventListener('keydown', function (e) {
      if (e.key !== 'Enter') return;
      var list = paintSearch();
      if (list[0]) location.href = list[0].url;
    });
    search.addEventListener('click', function (e) {
      if (e.target !== search) return;
      var r = search.getBoundingClientRect();
      if (e.clientX < r.left || e.clientX > r.right || e.clientY < r.top || e.clientY > r.bottom) search.close();
    });
  }

  /* -------------------------------------------------------------- Cookies */
  // Solo se pide consentimiento para analítica y marketing. La decisión se guarda con la
  // Customer Privacy API de Shopify, que la aplica a sus píxeles y a las apps instaladas.
  var banner = $('[data-cookie-banner]');
  var KEY = 'ad-cookies';
  function stored() { try { return localStorage.getItem(KEY); } catch (e) { return null; } }
  function showBanner(reopen) {
    if (!banner) return;
    var consent = stored();
    $('[data-cookie-state]', banner).textContent =
      consent === 'yes' ? ' Ahora mismo tienes aceptada la analítica.' : consent === 'no' ? ' Ahora mismo solo usamos las cookies necesarias.' : '';
    banner.hidden = !(reopen || (consent !== 'yes' && consent !== 'no'));
  }
  function applyConsent(value) {
    var yes = value === 'yes';
    var api = window.Shopify && window.Shopify.customerPrivacy;
    if (api && api.setTrackingConsent) {
      // La política de cookies solo contempla analítica: marketing y venta de datos, siempre no.
      api.setTrackingConsent({ analytics: yes, marketing: false, preferences: yes, sale_of_data: false }, function () {});
    }
  }
  if (banner) {
    if (window.Shopify && window.Shopify.loadFeatures) {
      window.Shopify.loadFeatures([{ name: 'consent-tracking-api', version: '0.1' }], function (error) {
        if (!error && (stored() === 'yes' || stored() === 'no')) applyConsent(stored());
      });
    }
    $$('[data-cookie-decide]', banner).forEach(function (b) {
      b.addEventListener('click', function () {
        var v = b.dataset.cookieDecide;
        var prev = stored();
        try { localStorage.setItem(KEY, v); } catch (e) {}
        applyConsent(v);
        banner.hidden = true;
        if (v === 'no' && prev === 'yes') location.reload();
      });
    });
    // Enlaces y botones que vuelven a abrir el aviso (política de cookies): RGPD art. 7.3.
    document.addEventListener('click', function (e) {
      var a = e.target.closest('a[href$="#cookies"], [data-cookie-settings]');
      if (!a) return;
      e.preventDefault();
      showBanner(true);
    });
    showBanner(false);
  }
})();
